"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src253626114/src/mrt-covid19-center/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clickable = exports.icon = void 0;

var react_1 = require("@emotion/react");

exports.icon = react_1.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline-block;\n  border: 0;\n"])));
exports.clickable = react_1.css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n\n  &:hover {\n    background-color: var(--gray-80);\n    border-radius: 4px;\n  }\n"])));